import React from 'react';
import { getTheme } from '@uifabric/styling';
import { Persona } from 'office-ui-fabric-react';
import { Link } from '../Link';
import { ElevatedStack } from '../Stack/ElevatedStack';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const CardLink = _ref => {
  let {
    href,
    code,
    text,
    testId,
    isDisabled,
    disableTextColor = getTheme().palette.neutralSecondary,
    children
  } = _ref;
  const cardStyles = {
    root: {
      alignItems: 'center',
      height: '100%',
      width: '100%',
      padding: 10
    }
  };
  const linkRootStyles = {
    textDecoration: 'none !important',
    display: 'contents'
  };
  return /*#__PURE__*/_jsx(ElevatedStack, {
    styles: cardStyles,
    horizontal: true,
    children: /*#__PURE__*/_jsxs(Link, {
      href: href,
      styles: {
        root: linkRootStyles
      },
      children: [/*#__PURE__*/_jsx(Persona, {
        "data-id": testId,
        imageInitials: code,
        text: text,
        coinProps: {
          styles: {
            initials: {
              borderRadius: '5%',
              fontSize: 14
            }
          }
        },
        styles: {
          primaryText: {
            whiteSpace: 'wrap',
            color: isDisabled ? disableTextColor : undefined
          }
        },
        coinSize: 52,
        initialsColor: isDisabled ? disableTextColor : undefined
      }), children]
    })
  });
};